(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-shipping"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", async function() {
    const results = {};

    async function fetch_rates(country, zip) {
      await fetch(window.Shopify.routes.root + `cart/prepare_shipping_rates.json`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ shipping_address: { country, zip } }),
      });
      var rates = null;
      for (let i = 0; !rates && i < 10; ++i) {
        try {
          rates = await fetch(window.Shopify.routes.root + `cart/async_shipping_rates.json?shipping_address%5Bzip%5D=${encodeURIComponent(zip)}&shipping_address%5Bcountry%5D=${encodeURIComponent(country)}`).then((json) => json.json());
        } catch {
        }
        if (rates === null) await new Promise((resolve) => setTimeout(resolve, 50));
      }
      return rates;
    }

    async function get_shipping_estimate(country, zip) {
      let result = results[country] ? results[country][zip] : null;
      if (result) return result;
      result = fetch_rates(country, zip);
      if (!results[country]) results[country] = {};
      results[country][zip] = result;
      return await result;
    }

    async function get_best_shipping_rate(country, zip) {
      const rates = (await get_shipping_estimate(country, zip)).shipping_rates;
      if (!rates) return null;
      return rates.reduce((min, current) => {
        return current.price < min.price ? current : min;
      });
    }

    document.querySelectorAll(".cart-shipping").forEach(async (e) => {
      const zip = e.dataset.zip;
      const country = e.dataset.country;
      if (!zip || !zip.length || !country || !country.length) return;
      const rate = await get_best_shipping_rate(country, zip);
      if (!rate) return;
      e.classList.remove("hidden");
      const formattedPrice = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: rate.currency,
      }).format(parseFloat(rate.price));
      const estimate = rate.price == "0.00"
        ? "Free shipping"
        : `Shipping from ${formattedPrice}`;
      e.querySelector(":scope span.shipping-estimate").innerHTML = estimate;
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["contact-form-mercia"] && !Shopify.designMode) return;
  try {
    function toggleOrderNumber(select) {
    const form = select.closest('form');
    const orderNumberField = form.querySelector('.order-number-field');
    const orderNumberInput = form.querySelector('.contact-form__order-number');

    const show = select.value === 'Order query' || select.value === 'Delivery/returns query';
    orderNumberField.style.display = show ? 'block' : 'none';
    orderNumberInput.toggleAttribute('required', show);
  }

  function initOrderNumberToggles(root = document) {
    root.querySelectorAll('.contact-form__form select[name="contact[enquiry_type]"]').forEach(select => {
      select.addEventListener('change', () => toggleOrderNumber(select));
      
      toggleOrderNumber(select);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initOrderNumberToggles());
  } catch(e) { console.error(e); }
})();

})();
